import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import TeacherApplicationsTable from './TeacherApplicationsTable';

const TeacherApplications = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Teacher Applications' parent='Teachers' />
      <Container fluid={true}>
        <Row>
          <TeacherApplicationsTable />
        </Row>
      </Container>
    </Fragment>
  );
};

export default TeacherApplications;
